import React, {createContext, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';

import { ACCESS_KEY } from '@app/api/auth';

import { RNQueryContext } from './rn-query';
import {versionCompare} from '../utils/version';
import AppVersionModal from '../components/version/modal';
import { REQUIRED_APP_VER } from '../utils/constants';

const APP_VERSION_EVENT = 'AppVersion';
const APP_NAVIGATE_EVENT = 'Navigate';


export type DeviceInfo = {
  brand: string,
  manufacturer: string,
  model: string
  designName: string
  productName: string
  totalMemory: string
  osName: string
  osVersion: string
}

export type AppVersion = {
  version: string,
  os: string,
  open: boolean
  device: DeviceInfo
};

export const RNAppVersionContext = createContext<AppVersion>({
  version: REQUIRED_APP_VER,
  os: '',
  open: false,
  device: {
    brand: '',
    manufacturer: '',
    model: '',
    designName: '',
    productName: '',
    totalMemory: '',
    osName: '',
    osVersion: '',

  }
});

export const RNAppVersionContextProvider = ({ children, onLogin }) => {
  const { push } = useHistory();
  const [appVersionState, setAppVersionState] = useState<AppVersion>({
    version: '',
    os: '',
    open: false,
    device: {
      brand: '',
      manufacturer: '',
      model: '',
      designName: '',
      productName: '',
      totalMemory: '',
      osName: '',
      osVersion: ''
    }
  });

  const { on } = useContext(RNQueryContext);

  useEffect(() => {
    const off = on<{token: string, version: string, os: string, device: DeviceInfo}>(APP_VERSION_EVENT, ({ token, version, os, device}) => {
      if(token) {
        console.log('Login from RN');
        localStorage.setItem(ACCESS_KEY, token);
        onLogin?.();
      }
      setAppVersionState({
        version, os,
        open: versionCompare(REQUIRED_APP_VER, version, {}) !== 0,
        device,
      });
      off();
    });

    const offNavigate = on<{to: string}>(APP_NAVIGATE_EVENT, ({ to }) => {
      push(to);
    });

    return offNavigate;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (<RNAppVersionContext.Provider value={appVersionState}>
    {children}
    {/* <AppVersionModal required={REQUIRED_APP_VER} {...appVersionState} onClose={() => setAppVersionState({...appVersionState, open: false})}/> */}
  </RNAppVersionContext.Provider>);
};